import {
  Component, Input, Output, EventEmitter,
  ChangeDetectionStrategy, ViewChild
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { OverlayPanelModule, OverlayPanel } from 'primeng/overlaypanel';

@Component({
  selector: 'app-task-hover-actions',
  standalone: true,
  imports: [CommonModule, TooltipModule, OverlayPanelModule],
  templateUrl: './task-hover-actions.component.html',
  styleUrls: ['./task-hover-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskHoverActionsComponent {
  @Input() task: any;
  @Input() isTimerRunning = false;
  @Input() isTimerPaused  = false;
  @Input() timerElapsed   = 0;
  @Input() isProjectMember = false;
  @Input() isSubtask = false;
  @Input() isCreateAccess = true;
  @Input() isEditAccess = true;
  @Input() isDeleteAccess = true;
  // Off unless the page turns it on, so other pages keep the same pill
  @Input() canCopyMove = false;

  @Output() openTask        = new EventEmitter<void>();
  @Output() editTask        = new EventEmitter<void>();
  @Output() addSubtask      = new EventEmitter<void>();
  @Output() deleteTask      = new EventEmitter<void>();
  @Output() logTime         = new EventEmitter<void>();
  @Output() copyLink        = new EventEmitter<void>();
  @Output() startTimer      = new EventEmitter<void>();
  @Output() pauseTimer      = new EventEmitter<void>();
  @Output() resumeTimer     = new EventEmitter<void>();
  @Output() stopTimer       = new EventEmitter<void>();
  @Output() setDueDate      = new EventEmitter<MouseEvent>();
  @Output() setProgress     = new EventEmitter<MouseEvent>();
  @Output() setPriority     = new EventEmitter<MouseEvent>();
  @Output() setStatus       = new EventEmitter<MouseEvent>();
  @Output() setGroup        = new EventEmitter<MouseEvent>();
  @Output() addTag          = new EventEmitter<MouseEvent>();
  @Output() copyMove        = new EventEmitter<void>();

  @ViewChild('morePanel') morePanel!: OverlayPanel;

  formatTime(seconds: number): string {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    return h > 0
      ? `${h}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`
      : `${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
  }

  stop(e: Event) { e.stopPropagation(); }
}
